export const invertColor = (rgb) => {
  const r = rgb[0],
        g = rgb[1],
        b = rgb[2];
  return (255 - r) + ',' + (255 - g) + ',' + (255 - b);
}
